// import { stateToHTML } from 'draft-js-export-html';
import { convertFromRaw, Editor, EditorState } from "draft-js";
import { ToggleWF } from "../Workflows/FacilityBreakdownWorkFlowComponent";

const FacilityBreakdownQuestionnaireSingleSelectionPropertyComponent = ({ props }) => {
    return (props && props.find(x => x.property === 'Options') && <div>
        <table className='table table-sm'>
            <thead>
                <tr>
                    <th>Option</th>
                    <th>Weight</th>
                    <th>Labels</th>
                </tr>
            </thead>
            <tbody>
                {JSON.parse(props.filter(x => x.property === 'Options')[0].values).map(p =>
                    <tr>
                        <td>{p.option && p.option}</td>
                        <td>{p.weight && p.weight}</td>
                        <td>{p.Labels && p.Labels}</td>
                    </tr>
                )}
            </tbody>
        </table>
    </div>)
}

const FacilityBreakdownQuestionnairePropertyComponent = ({ prop }) => {
    switch (prop.property) {
        case 'Question': return <div><b>Question</b> {prop.values}</div>
        case 'Options': return <div><b>Options </b>
            {prop.values && JSON.parse(prop.values).map(o =>
                <div className='ms-5'>
                    <div><b>Option </b>{o.option}</div>
                    {o.weight && <div><b>weight</b> {o.weight}</div>}
                    {/* {o.weight && <div><b>weight</b> {o.weight}</div>} */}
                    {o.Labels && <div><b>Labels </b>{JSON.stringify(o.Labels)}</div>}
                </div>
            )}</div>
        default: return <div><b>{prop.property} </b> {prop.values}</div>
    }
}

const FacilityBreakdownQuestionnaireSimpleComponent = ({ type, props }) => {
    const findProperty = (prop) => {
        if (!props) return
        const p = props.find(a => a.property === prop)
        return p ? p.values.replaceAll('"', '') : undefined

    }
    return (<div><b>Type : </b>{type} <b>Question : </b>{findProperty("Question")}</div>)
}
const FacilityBreakdownDynamicTableComponent = ({ props }) => {
    const findProperty = (prop) => {
        const p = props.find(a => a.property === prop)
        return p ? p.values.replaceAll('"', '') : undefined
    }
    const findItems = () => {
        const p = props.find(a => a.property === 'Items')
        return p ? JSON.parse(p.values) : []
    }
    return (<div>
        <div><b>Type</b> Dynamic Table</div>
        <div><b>Question</b> {findProperty('Question')}</div>
        <div className="ms-3">
            {/* <pre>{JSON.stringify(findItems(), '\t', 2)}</pre> */}
            {findItems().map(i => <div>
                {i.name && <div><b>Name</b> {i.name}
                    <div className="ms-2">
                        <RenderComponent component={{
                            componentType: i.type
                        }} />
                    </div>
                </div>}
            </div>)}
            {/* {findItems().map(i => <RenderComponent component={{
                componentType: i.type.type,
                properties: []
            }} />)} */}
        </div>
    </div>)
}

const RenderComponent = (component) => {
    const _component = component.component
    return (<div>
        {

            _component.componentType &&
            (
                {
                    'Date Picker': <FacilityBreakdownQuestionnaireSimpleComponent type={'Date Picker'} props={_component.properties} />,
                    'Facilities': <FacilityBreakdownQuestionnaireSimpleComponent type={'Facility Selection'} props={_component.properties} />,
                    'Get Input text': <FacilityBreakdownQuestionnaireSimpleComponent type={'Text Input'} props={_component.properties} />,
                    'Single Selection': <FacilityBreakdownQuestionnaireSingleSelectionPropertyComponent props={_component.properties && _component.properties.filter(x => x.property !== 'Question')} />,
                    'Display Text': <RTEPreview template={_component.properties && _component.properties.find(p => p.property === 'Question') && _component.properties.find(p => p.property === 'Question').values} />,
                    'Dynamic Component Table': <FacilityBreakdownDynamicTableComponent props={_component.properties} />,
                }[_component.componentType.type] || <span className='ms-4'>
                    {_component.properties && _component.properties.filter(x => x.property !== 'Question')
                        .map(p => <FacilityBreakdownQuestionnairePropertyComponent prop={p} />)}
                    {JSON.stringify(_component.componentType.type)}
                </span>
            )
        }
    </div>)
}
export const FacilityBreakdownQuestionnaireComponent = ({ questionnaire }) => {
    return (<div className="bg-light text-dark rounded p-2 m-2" style={{ fontSize: '1rem' }}>
        <ToggleWF title={questionnaire.name}>
            <div>
                {questionnaire.sections && questionnaire.sections.length > 0 ?
                    <>
                        <b>Sections</b>
                        {questionnaire.sections.map(s => <div>
                            <div className='ms-2'>{s.name}</div>
                            {s.components ?
                                <>
                                    <b>Components</b>
                                    {s.components.map(s => <RenderComponent component={{ ...s }} />)}
                                </>
                                : <div className='text-center'><i>No Components</i></div>
                            }
                        </div>)}
                    </>
                    : <div className='text-center'><i>No Sections</i></div>
                }
            </div>
        </ToggleWF>
    </div>)
}

const RTEPreview = ({ template }) => {
    const ParseValue = () => {
        try {
            return EditorState.createWithContent(convertFromRaw(typeof template === 'string' ? JSON.parse(template) : template))
        } catch (e) {
            // console.log(`Failed to process template ${JSON.stringify(template)}`)
            return EditorState.createEmpty()
        }
    }

    return <Editor
        readOnly
        editorState={ParseValue()}
    />
}